import { IBFHistoryRecordDefinition } from "@/lib/drivers/insulet/IBFHistoryLogs/HistoryRecordParser";

export type IBFResume = {};

export const IBF_RESUME = {
  value: 0x10000,
  name: "IBF_RESUME",
  size: 0,
  parse: (): IBFResume => {
    return {};
  },
} satisfies IBFHistoryRecordDefinition<IBFResume>;
